/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** VoteChoice */
export enum VoteChoice {
  Yes = 'yes',
  No = 'no',
}

/** BoardRequestStatus */
export enum BoardRequestStatus {
  Draft = 'draft',
  BoardVoting = 'boardVoting',
  ReadyForPmReview = 'readyForPmReview',
  Approved = 'approved',
  Denied = 'denied',
  Cancelled = 'cancelled',
}

/** BoardRequestPmDecision */
export enum BoardRequestPmDecision {
  Approved = 'approved',
  Denied = 'denied',
}

/** AddBoardRequestFilesDto */
export interface AddBoardRequestFilesDto {
  uploadSessionIds: string[];
}

/** AppointHoaBoardMemberDto */
export interface AppointHoaBoardMemberDto {
  ownerId: string;
  role?: string;
}

/** BoardRequestDto */
export interface BoardRequestDto {
  id: string;
  companyId: string;
  portfolioId?: string;
  propertyId: string;
  propertyName?: string;
  unitId?: string;
  unitName?: string;
  submittedByOwnerId: string;
  submittedByOwnerName?: string;
  title: string;
  description: string;
  status: BoardRequestStatus;
  /** @format date-time */
  dueAt?: string;
  isOverdue: boolean;
  voteSessionId?: string;
  boardRequestProgress?: BoardRequestProgressDto;
  pmDecision?: BoardRequestPmDecision;
  /** @format date-time */
  pmDecidedAt?: string;
  pmNote?: string;
  files: BoardRequestFileDto[];
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** BoardRequestFileDto */
export interface BoardRequestFileDto {
  fileId: string;
  description?: string;
}

/** BoardRequestProgressDto */
export interface BoardRequestProgressDto {
  voteQuestionId: string;
  /** @format int32 */
  yes: number;
  /** @format int32 */
  no: number;
  /** @format int32 */
  pending: number;
  /** @format int32 */
  total: number;
  voters?: BoardRequestProgressVoterDto[];
}

/** BoardRequestProgressVoterDto */
export interface BoardRequestProgressVoterDto {
  ownerId: string;
  name?: string;
  choice?: VoteChoice;
  /** @format date-time */
  castAt?: string;
}

/** BoardRequestsPageDto */
export interface BoardRequestsPageDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: BoardRequestDto[];
}

/** CreateBoardRequestDto */
export interface CreateBoardRequestDto {
  propertyId: string;
  unitId?: string;
  portfolioId?: string;
  title: string;
  description: string;
  /** @format date-time */
  dueAt?: string;
  submittedByOwnerId?: string;
  files?: BoardRequestFileDto[];
}

/** CreateOptionDto */
export interface CreateOptionDto {
  /** @format int32 */
  order: number;
  text: string;
}

/** CreateQuestionDto */
export interface CreateQuestionDto {
  /** @format int32 */
  order: number;
  text: string;
  type: string;
  isRequired: boolean;
  options?: CreateOptionDto[];
}

/** CreateSurveyDto */
export interface CreateSurveyDto {
  title: string;
  description: string;
  audience: string;
  /** @format date-time */
  closesAt?: string;
  questions: CreateQuestionDto[];
}

/** DecideBoardRequestDto */
export interface DecideBoardRequestDto {
  note?: string;
}

/** FreeTextResponseDto */
export interface FreeTextResponseDto {
  ownerId: string;
  ownerName?: string;
  answer: string;
}

/** HoaBoardMemberDto */
export interface HoaBoardMemberDto {
  id: string;
  companyId: string;
  ownerId: string;
  active: boolean;
  role?: string;
  /** @format date-time */
  seatStartedAt: string;
  /** @format date-time */
  seatEndedAt?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** HoaBoardMembersDto */
export interface HoaBoardMembersDto {
  items: HoaBoardMemberDto[];
}

/** OptionDto */
export interface OptionDto {
  id: string;
  /** @format int32 */
  order: number;
  text: string;
}

/** OptionResultDto */
export interface OptionResultDto {
  optionId: string;
  text: string;
  /** @format int32 */
  count: number;
}

/** QuestionDto */
export interface QuestionDto {
  id: string;
  /** @format int32 */
  order: number;
  text: string;
  type: string;
  isRequired: boolean;
  options?: OptionDto[];
}

/** QuestionResultDto */
export interface QuestionResultDto {
  questionId: string;
  /** @format int32 */
  order: number;
  text: string;
  type: string;
  /** @format int32 */
  yesCount?: number;
  /** @format int32 */
  noCount?: number;
  options?: OptionResultDto[];
  /** @format int32 */
  responseCount?: number;
  responses?: FreeTextResponseDto[];
  /** @format int32 */
  skippedCount: number;
}

/** RemoveBoardRequestFilesDto */
export interface RemoveBoardRequestFilesDto {
  fileIds: string[];
}

/** RequestAndVotingSummaryDto */
export interface RequestAndVotingSummaryDto {
  /** @format int32 */
  pendingReviewCount: number;
  /** @format int32 */
  boardVotingCount: number;
  /** @format int32 */
  overdueCount: number;
}

/** RequestUploadSessionDto */
export interface RequestUploadSessionDto {
  /**
   * @minLength 1
   * @maxLength 250
   */
  fileName: string;
  /**
   * @format int32
   * @min 1
   * @max 9223372036854776000
   */
  fileSize: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  contentType: string;
}

/** SurveyDto */
export interface SurveyDto {
  id: string;
  title: string;
  description: string;
  audience: string;
  status: string;
  /** @format date-time */
  closesAt?: string;
  questions: QuestionDto[];
  /** @format int32 */
  responseCount: number;
  /** @format int32 */
  eligibleCount?: number;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** SurveyListDto */
export interface SurveyListDto {
  items: SurveyListItemDto[];
  /** @format int32 */
  totalCount: number;
}

/** SurveyListItemDto */
export interface SurveyListItemDto {
  id: string;
  title: string;
  audience: string;
  status: string;
  /** @format date-time */
  closesAt?: string;
  /** @format int32 */
  questionCount: number;
  /** @format int32 */
  responseCount: number;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** SurveyResultsDto */
export interface SurveyResultsDto {
  surveyId: string;
  title: string;
  status: string;
  /** @format int32 */
  eligibleCount: number;
  /** @format int32 */
  responseCount: number;
  /** @format double */
  responseRate: number;
  questions: QuestionResultDto[];
}

/** UpdateDueAtDto */
export interface UpdateDueAtDto {
  /** @format date-time */
  dueAt?: string;
}

/** UpdateOptionDto */
export interface UpdateOptionDto {
  id?: string;
  /** @format int32 */
  order: number;
  text: string;
}

/** UpdateQuestionDto */
export interface UpdateQuestionDto {
  id?: string;
  /** @format int32 */
  order: number;
  text: string;
  type: string;
  isRequired: boolean;
  options?: UpdateOptionDto[];
}

/** UpdateSurveyDto */
export interface UpdateSurveyDto {
  title?: string;
  description?: string;
  audience?: string;
  /** @format date-time */
  closesAt?: string;
  questions?: UpdateQuestionDto[];
}

/** UploadSessionDto */
export interface UploadSessionDto {
  sessionId: string;
  endpoint: string;
  method: string;
  fields: Record<string, string>;
  /** @format date-time */
  expires: string;
}

export interface ListBoardRequestsParams {
  statuses?: BoardRequestStatus[];
  propertyIds?: string[];
  isOverdue?: boolean;
  /** @format int32 */
  currentPage?: number;
  /** @format int32 */
  pageSize?: number;
}

export interface GetBoardRequestParams {
  /** @format int64 */
  boardRequestId: string;
}

export interface ForcePmReviewParams {
  /** @format int64 */
  boardRequestId: string;
}

export interface ApproveParams {
  /** @format int64 */
  boardRequestId: string;
}

export interface DenyParams {
  /** @format int64 */
  boardRequestId: string;
}

export interface UpdateDueAtParams {
  /** @format int64 */
  boardRequestId: string;
}

export interface CancelParams {
  /** @format int64 */
  boardRequestId: string;
}

export interface RequestFileUploadSessionParams {
  /** @format int64 */
  boardRequestId: string;
}

export interface AddFilesParams {
  /** @format int64 */
  boardRequestId: string;
}

export interface RemoveFilesParams {
  /** @format int64 */
  boardRequestId: string;
}

export interface ListBoardMembersParams {
  active?: boolean;
}

export interface GetBoardMemberByOwnerIdParams {
  /** @format int64 */
  ownerId: string;
}

export interface GetBoardMemberParams {
  /** @format int64 */
  boardMemberId: string;
}

export interface DeactivateBoardMemberParams {
  /** @format int64 */
  boardMemberId: string;
}

export interface ListSurveysParams {
  /** @format int32 */
  currentPage?: number;
  /** @format int32 */
  pageSize?: number;
  statuses?: string[];
  audiences?: string[];
}

export interface UpdateSurveyParams {
  /** @format int64 */
  surveyId: string;
}

export interface GetSurveyParams {
  /** @format int64 */
  surveyId: string;
}

export interface PublishSurveyParams {
  /** @format int64 */
  surveyId: string;
}

export interface CloseSurveyParams {
  /** @format int64 */
  surveyId: string;
}

export interface GetSurveyResultsParams {
  /** @format int64 */
  surveyId: string;
}
